import React from "react";
import privacyData from "./privacyPolicy.json";

const PrivacyPolicy = () => {
    return (
        <div style={styles.container}>
            <h1 style={styles.title}>{privacyData.title}</h1>
            <p style={styles.updated}>Last Updated: {privacyData.lastUpdated}</p>
            <p style={styles.intro}>{privacyData.intro}</p>

            {privacyData.sections.map((section, index) => (
                <div key={index} style={styles.section}>
                    <h2 style={styles.heading}>{section.heading}</h2>
                    {section.content.map((line, i) => (
                        <p key={i} style={styles.text}>
                            {line}
                        </p>
                    ))}
                </div>
            ))}
        </div>
    );
};

const styles = {
    container: {
        maxWidth: "800px",
        margin: "0 auto",
        padding: "40px 20px",
        fontFamily: "Inter, sans-serif",
        color: "#333",
        lineHeight: 1.6
    },
    title: {
        fontSize: "28px",
        fontWeight: "700",
        marginBottom: "10px"
    },
    updated: {
        color: "#888",
        fontSize: "14px",
        marginBottom: "20px"
    },
    intro: {
        marginBottom: "20px"
    },
    section: {
        marginBottom: "30px"
    },
    heading: {
        fontSize: "18px",
        fontWeight: "600",
        marginBottom: "10px"
    },
    text: {
        marginBottom: "8px"
    }
};

export default PrivacyPolicy;
